// ======================================================================
// File Name       : InformationModal
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal, Col } from 'react-bootstrap';
import FormControlValidate from '../FormControlValidate';

class InformationModal extends React.Component {
  render() {
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={this.props.mdSize}
      >
        {this.props.title && (
          <Modal.Header>
            <Modal.Title className="text-center">
              {this.props.title}
            </Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body className="text-center">
          <Col sm={12}>
            <p className="line-height-20">{this.props.content}</p>
          </Col>
          <Col sm={12} className="margin-top-10">
            <FormControlValidate
              value={this.props.value}
              as="textarea"
              name="denialReason"
              // START #5611
              readOnly
              rows={9}
              // END #5611
            />
          </Col>
        </Modal.Body>

        <Modal.Footer className="text-center">
          <Button
            className=" margin-right-10 btn-96"
            variant="primary"
            onClick={this.props.onOK}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

InformationModal.defaultProps = { animation: true };
export default InformationModal;
